export default {
  setNomenclature (state, items) {
    state.items = items
  },
}
